var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "dialog",
        height: "auto",
        classes: ["v--modal", "vue-dialog", this.params.class],
        width: _vm.width,
        "pivot-y": 0.3,
        adaptive: true,
        clickToClose: _vm.clickToClose,
        transition: _vm.transition
      },
      on: {
        "before-open": _vm.beforeOpened,
        "before-close": _vm.beforeClosed,
        opened: function($event) {
          return _vm.$emit("opened", $event)
        },
        closed: function($event) {
          return _vm.$emit("closed", $event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c("div", { staticClass: "modal-header" }, [
            _vm.params.title
              ? _c(
                  "h5",
                  {
                    staticClass: "modal-title h4",
                    domProps: { innerHTML: _vm._s(_vm.params.title || "") }
                  },
                  [_vm._v("Small Modal")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                },
                on: {
                  click: function($event) {
                    return _vm.closeClick($event)
                  }
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _vm.params.component
            ? _c(
                _vm.params.component,
                _vm._b(
                  { tag: "component" },
                  "component",
                  _vm.params.props,
                  false
                )
              )
            : _c("div", {
                staticClass: "modal-body",
                staticStyle: { "word-break": "break-all" },
                domProps: { innerHTML: _vm._s(_vm.params.text || "") }
              }),
          _vm._v(" "),
          _vm.buttons
            ? _c(
                "div",
                { staticClass: "modal-footer" },
                _vm._l(_vm.buttons, function(button, i) {
                  return _c(
                    "button",
                    {
                      key: i,
                      class: button.default
                        ? "btn btn-secondary"
                        : "btn btn-primary",
                      attrs: { type: "button" },
                      domProps: { innerHTML: _vm._s(button.title) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.click(i, $event)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(button.title) + "\n      ")]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "vue-dialog-buttons-none" })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b0b6380", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0b6380","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/modal/Dialog.vue
// module id = null
// module chunks = 